import React from 'react';
import { Box, Text, Checkbox, Heading } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import s from './AcceptTerms.scss';
import { useBiLogger } from '../../../../hooks/useBiLogger/useBiLogger';
import { BI_CONSTANTS } from '../../../../hooks/useBiLogger/biConstants';
import { dataHooks } from '../../datahooks';
import {
  APP_MARKET_TERMS_LINK,
  MODALYST_TERMS_LINK,
  SERVICE_FEES_LINK,
  TERMS_AND_CONDITIONS_LINK,
  MODALYST_PRIVACY_POLICY,
} from '../../../../consts';

interface AcceptPaymentsProps {
  onCheckboxChange: () => void;
  isAccepted?: boolean;
  isShowPayments?: boolean;
}

export const AcceptTerms: React.FC<AcceptPaymentsProps> = ({
  onCheckboxChange,
  isAccepted,
  isShowPayments,
}) => {
  const { t } = useTranslation();
  const biLogger = useBiLogger();
  const { ACTION, BUTTON_NAME } = BI_CONSTANTS;

  const onClick = async () => {
    biLogger.actionClicked({ action: ACTION.ACCEPT_PAYMENTS_ACCEPT, button_name: BUTTON_NAME.ACCEPT });
    onCheckboxChange();
  };

  return (
    <Box direction="vertical" width="100%" dataHook={dataHooks.acceptPaymentsWidget} gap={1}>
      <Heading className={s.heading} size="tiny">
        {t('SUPPLIER_HUB_AND_GETTING_PAID')}
      </Heading>

      <Text size="small">{t('SUPPLIER_HUB_AND_GETTING_PAID_DESCRIPTION')}</Text>

      <Box gap="12px" marginTop="12px" verticalAlign="top">
        <Checkbox checked={true} disabled dataHook={dataHooks.modalystTermsCheckbox} />

        <Text size="small">
          <Trans
            i18nKey="accept_terms.checkbox.app_terms"
            components={{
              appMarketLink: (
                <a href={APP_MARKET_TERMS_LINK} target="_blank" rel="noopener noreferrer">
                  -
                </a>
              ),
              modalystLink: (
                <a href={MODALYST_TERMS_LINK} target="_blank" rel="noopener noreferrer">
                  -
                </a>
              ),
              modalystPrivacyLink: (
                <a href={MODALYST_PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
                  -
                </a>
              ),
            }}
          />
        </Text>
      </Box>

      {isShowPayments && (
        <Checkbox
          className={s.checkbox}
          checked={isAccepted}
          onChange={() => onClick()}
          dataHook={dataHooks.acceptPaymentsCheckbox}
          vAlign="top"
        >
          <Text size="small">
            <Trans
              i18nKey="accept_terms.checkbox.payment_terms"
              components={{
                paymentsLink: (
                  <a href={TERMS_AND_CONDITIONS_LINK} target="_blank" rel="noopener noreferrer">
                    -
                  </a>
                ),
                serviceFeesLink: (
                  <a href={SERVICE_FEES_LINK} target="_blank" rel="noopener noreferrer">
                    -
                  </a>
                ),
              }}
            />
          </Text>
        </Checkbox>
      )}
    </Box>
  );
};
